function _arrayLikeToArray(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function _arrayWithoutHoles(arr) {
    if (Array.isArray(arr)) return _arrayLikeToArray(arr);
}
function _iterableToArray(iter) {
    if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter);
}
function _nonIterableSpread() {
    throw new TypeError("Invalid attempt to spread non-iterable instance.\\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function _toConsumableArray(arr) {
    return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _unsupportedIterableToArray(arr) || _nonIterableSpread();
}
function _unsupportedIterableToArray(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return _arrayLikeToArray(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(n);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen);
}
import { defineComponent, computed } from "vue";
import PtCascaderNode from "./pt-cascader-node.vue";
import { definePropType } from "@types-vue/props";
export default defineComponent({
    name: "PtCascaderMenu",
    components: {
        PtCascaderNode: PtCascaderNode
    },
    props: {
        value: {
            type: definePropType([
                Array,
                String,
                Number, 
            ])
        },
        multiple: {
            type: Boolean,
            default: false
        },
        selectable: {
            type: Boolean,
            default: false
        },
        nodes: {
            type: definePropType(Array),
            required: true
        },
        expandValue: {},
        isLeaf: {
            type: Boolean
        }
    },
    setup: function setup(props, param) {
        var emit = param.emit;
        var isChecked = function isChecked(v) {
            return Array.isArray(props.value) ? props.value.includes(v) : props.value === v;
        };
        var handleNodeChange = function handleNodeChange(value, checked) {
            if (props.multiple) {
                var result = Array.isArray(props.value) ? _toConsumableArray(props.value) : [];
                var index = result.findIndex(function(v) {
                    return v === value;
                });
                if (checked) {
                    if (index === -1) {
                        result.push(value);
                    }
                } else {
                    if (index !== -1) {
                        result.splice(index, 1);
                    }
                }
                emit("input", result);
            } else {
                console.log("handleNodeChange", value, checked);
                emit("input", checked ? [
                    value
                ] : "");
            }
        };
        var checkedType = computed(function() {
            if (!props.selectable) return undefined;
            return props.multiple ? "checkbox" : "radio";
        });
        return {
            checkedType: checkedType,
            isChecked: isChecked,
            handleNodeChange: handleNodeChange
        };
    }
});
